import React from 'react';
import { Table } from '@gerdau/hefesto-mais-web';
import { TextField } from '@gerdau/hefesto';
import { IResponsibleOfConstruction } from '../../../../../store/ducks/fabrication-contracts/types';
import RemoveItemButtonFacelift from '../../../../../components/RemoveItemButton/Facelift/index';
import { isValidEmail } from '../../../../../utils/validateInputs';

interface IResponsibleItem {
  responsibles: IResponsibleOfConstruction[];
  setResponsible(item: IResponsibleOfConstruction): void;
  onRemoveItem?(index: number): void;
  isTheOnlyItem?: boolean;
}

const ResponsibleItem: React.FC<IResponsibleItem> = ({
  responsibles,
  setResponsible,
  onRemoveItem,
  isTheOnlyItem
}) => {
  const dataSource = responsibles.map((item, idx) => ({ ...item, key: idx }));

  const handleUpdateField = (
    field: string,
    value: string,
    updatedResponsible: IResponsibleOfConstruction
  ) => {
    const updatedItem = {
      ...updatedResponsible,
      [field]: value
    };
    setResponsible({
      ...updatedItem
    });
  };

  const canShowRemoveButton = (item: IResponsibleOfConstruction) => {
    const { name, email, phoneNumber, jobTitle } = item;
    return !isTheOnlyItem || name || email || phoneNumber || jobTitle;
  };

  const phoneInputValidator = (
    e: React.FormEvent<HTMLInputElement>,
    item: IResponsibleOfConstruction
  ) => {
    let value = e.currentTarget.value;
    value = value.replace(/\D/g, '');

    e.currentTarget.maxLength = 15;
    value = value.replace(/^(\d{2})(\d)/g, '($1) $2'); //Coloca parênteses em volta dos dois primeiros dígitos
    value = value.replace(/(\d)(\d{4})$/, '$1-$2'); //Coloca hífen entre o quarto e o quinto dígitos

    handleUpdateField('phoneNumber', value, item);
  };

  const getColumns = () => {
    const columns = [
      {
        title: 'Nome completo',
        dataIndex: '',
        render: (item: IResponsibleOfConstruction) => (
          <TextField
            data-testid="name"
            name="name"
            hideLabel
            label=""
            placeholder="Digite o nome"
            value={item.name}
            maxLength={100}
            onChange={(e) => handleUpdateField('name', e.target.value, item)}
          />
        )
      },
      {
        title: 'E-mail',
        dataIndex: '',
        render: (item: IResponsibleOfConstruction) => (
          <TextField
            data-testid="email"
            name="email"
            hideLabel
            label=""
            placeholder="Digite o e-mail"
            value={item.email}
            maxLength={100}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleUpdateField('email', e.target.value, item)
            }
            supportMessage={
              item.email && !isValidEmail(item.email)
                ? 'O valor digitado não é um e-mail válido'
                : ''
            }
            variant={
              item.email && !isValidEmail(item.email) ? 'danger' : undefined
            }
          />
        )
      },
      {
        title: 'Telefone ou celular',
        dataIndex: '',
        render: (item: IResponsibleOfConstruction) => (
          <TextField
            data-testid="phone-number"
            name="phone-number"
            hideLabel
            label=""
            placeholder="Digite o telefone"
            value={item.phoneNumber}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              phoneInputValidator(e, item)
            }
          />
        )
      },
      {
        title: 'Cargo',
        dataIndex: '',
        render: (item: IResponsibleOfConstruction) => (
          <TextField
            data-testid="job-title"
            name="job-title"
            hideLabel
            label=""
            placeholder="Digite o cargo"
            value={item.jobTitle}
            maxLength={100}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleUpdateField('jobTitle', e.target.value, item)
            }
          />
        )
      },
      {
        title: '',
        dataIndex: '',
        align: 'center' as const,
        render: (item: IResponsibleOfConstruction) => (
          <>
            {onRemoveItem !== undefined && canShowRemoveButton(item) && (
              <>
                <RemoveItemButtonFacelift
                  isResponsibleOfConstructionPage
                  onRemoveItem={() =>
                    item.key?.toString() && onRemoveItem(item.key)
                  }
                />
              </>
            )}
          </>
        )
      }
    ];
    return columns;
  };

  return <Table columns={getColumns()} dataSource={dataSource}></Table>;
};

export default ResponsibleItem;
